import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Button } from "react-bootstrap";
import { format } from "date-fns";
import { es } from "date-fns/locale";

import ServiceColumn from "./ServiceColumn";
import { formatNumberWithCommas } from "../../utils";
import { getOrderType } from "../../models/ReportOperatorSalary";
import ModalContainer from "../../components/ModalContainer";
import TablePayments from '../../pages/varo/orders/orderPayments/tablePayments';
import TableInvoices from '../../pages/varo/orders/orderPayments/tableInvoices';
import { useRef } from 'react';
import { Formik } from 'formik';

const TableOrderInvoicePayment = ({ orders, start, end }) => {
    const [openModalInfo, setOpenModalInfo] = useState(null);
    const [modalType, setModalType] = useState({ title: "", component: null });
    const tablePaymentsRef = useRef(null);

    const openModal = (order, type) => {
        if (!order.order_id) {
            console.error("order_id no está definido:", order);
            return;
        }
        setOpenModalInfo({ orderId: order.order_id, type });

        if (type === "invoices") { //TableInvoices
            setModalType({
                title: `Facturas de la orden con folio: ${order.folio?.toString().padStart(5, "0")}`,
                component: (
                    <>
                        {/* <h5 className="mt-10px"><i className="fa-solid fa-file-invoice"></i> Facturas a CONTADO</h5> */}
                        <h5 className="mt-10px text-start"><i className="fa-solid fa-file-invoice"></i> Facturas a CONTADO</h5>
                        <Formik initialValues={{ payments: [] }} onSubmit={() => { }}>
                            <TableInvoices
                                ref={tablePaymentsRef}
                                paymentTypeCode="CONTADO"
                                valuesKey="payments"
                                disabled={true}
                                orderId={order.order_id}
                                tipoOrden= {order.tipoOrden}
                            />
                        </Formik>

                        {/* <h5 className="mt-10px"><i className="fa-solid fa-file-invoice"></i> Facturas a CRÉDITO</h5> */}
                        <h5 className="mt-10px text-start"><i className="fa-solid fa-file-invoice"></i> Facturas a CRÉDITO</h5>

                        <Formik initialValues={{ payments: [] }} onSubmit={() => { }}>
                            <TableInvoices
                                ref={tablePaymentsRef}
                                paymentTypeCode="CREDITO"
                                valuesKey="payments"
                                disabled={true}
                                orderId={order.order_id}
                                tipoOrden= {order.tipoOrden}
                            />
                        </Formik>
                    </>
                )
            });
        } else if (type === "payments") {
            setModalType({
                title: `Pagos de la orden con folio: ${order.folio?.toString().padStart(5, "0")}`,
                component: (
                    <>
                        {/* <h5 className="mt-10px"><i className="fa-solid fa-sack-dollar"></i> Pagos a CONTADO</h5> */}
                        <h5 className="mt-10px text-start"><i className="fa-solid fa-sack-dollar"></i> Pagos a CONTADO</h5>
                        <Formik initialValues={{ payments: [] }} onSubmit={() => { }}>
                            <TablePayments
                                ref={tablePaymentsRef}
                                paymentTypeCode="CONTADO"
                                valuesKey="payments"
                                disabled={true}
                                orderId={order.order_id}
                                tipoOrden= {order.tipoOrden}
                            />
                        </Formik>

                        {/* <h5 className="mt-10px"><i className="fa-solid fa-sack-dollar"></i> Pagos a CRÉDITO</h5> */}
                        <h5 className="mt-10px text-start"><i className="fa-solid fa-sack-dollar"></i> Pagos a CRÉDITO</h5>

                        <Formik initialValues={{ payments: [] }} onSubmit={() => { }}>
                            <TablePayments
                                ref={tablePaymentsRef}
                                paymentTypeCode="CREDITO"
                                valuesKey="payments"
                                disabled={true}
                                orderId={order.order_id}
                                tipoOrden= {order.tipoOrden}
                            />
                        </Formik>
                    </>
                )
            });
        }
    };

    const closeModal = () => {
        setOpenModalInfo(null);
        setModalType({ title: "", component: null });
    };

    return (
        <div className="table-responsive mb-3">
            <table className="table table-hover table-panel text-nowrap align-middle mb-0">
                <thead className="sticky-thead table-light text-center">
                    <tr>
                        <th className="align-middle">Orden</th>
                        <th className="align-middle">Tipo de Servicio</th>
                        <th className="align-middle">Descripción del servicio</th>
                        <th className="align-middle">Fecha orden</th>
                        <th className="align-middle">Total (Sin IVA)</th>
                        <th className="align-middle">No pagos</th>
                        <th className="align-middle">No facturas</th>
                    </tr>
                </thead>

                <tbody>
                    {orders.map((order) => (
                        <tr className="text-center" key={order.order_id}>
                            <td>
                                <Row className="mb-2">
                                    <Col md="12">
                                        <Link to={order.tipo === "Varo Express"
                                            ? `/orders-vial/editOrder/${order.order_id}`
                                            : `/orders/edit/${order.order_id}`}
                                        >
                                            {order.folio.toString().padStart(5, "0")}
                                        </Link>
                                    </Col>
                                </Row>
                            </td>
                            <td>{order.tipoServicio?.trim() ? order.tipoServicio : getOrderType(order)}</td>
                            <td><ServiceColumn row={order} /></td>
                            <td>
                                {format(new Date(order.fecha_hora_reporte), "dd/MMM/yyyy", {
                                    locale: es,
                                })}
                            </td>
                            <td>${formatNumberWithCommas(order.subtotal) || Number(order.quick_order_price) || '0.00'}</td>
                            <td>
                                <>
                                    <Button size="sm" variant="info" onClick={() => openModal(order, "payments")}>
                                        Ver pagos: {order.totalPagos}

                                    </Button>
                                    <ModalContainer
                                        open={openModalInfo?.orderId === order.order_id && openModalInfo?.type === "payments"}
                                        closeFn={closeModal}
                                        title={modalType.title}
                                        children={modalType.component}
                                        size="xl"
                                    />
                                </>
                            </td>
                            <td>
                                <>
                                    <Button size="sm" variant="secondary" onClick={() => openModal(order, "invoices")}>
                                        Ver facturas: {order.totalFacturas}
                                    </Button>
                                    <ModalContainer
                                        open={openModalInfo?.orderId === order.order_id && openModalInfo?.type === "invoices"}
                                        closeFn={closeModal}
                                        title={modalType.title}
                                        children={modalType.component}
                                        size="xl"
                                    />
                                </>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default TableOrderInvoicePayment;
